module.exports = __webpack_public_path__ + "static/media/camera_white_filled.684497fa.svg";